import moment from 'moment';

function getDefaultRange() {
  return {
    startDate: moment().subtract(7, 'days'),
    endDate: moment().add(7, 'days')
  }
}

function rangeToButtonLabel(daterange) {
  return `${moment(daterange.startDate).format('MM/DD')} - ${moment(daterange.endDate).format('MM/DD')}`
}

function fromApiDate(dateInput, dateFormat = 'MM/DD/YYYY', timeFormat) {
  return `${moment.utc(dateInput, 'YYYY-MM-DD h:mm:ss').format('MM/DD/YYYY h:mm a')}`
}

function toApiDate(dateInput) {
  const dateOutput = `${moment(dateInput, 'MM/DD/YYYY h:mm A').format('YYYY-MM-DD HH:mm:ss')}`
  return dateOutput;
}

function getDuration(dateA, dateB) {
  const duration = moment.duration(moment(dateA, 'YYYY-MM-DD h:mm:ss').diff(moment(dateB, 'YYYY-MM-DD h:mm:ss')));
  const result = `
    ${generateDurationChunk(duration, 'days')} ${generateDurationChunk(duration, 'hours')} ${generateDurationChunk(duration, 'minutes')}`;
  return result.trim();
}

function generateDurationChunk(duration, label) {
  const amount = duration[label]();
  if (amount) {
    if (amount > 1) {
      return `${amount} ${label}`
    } else {
      return `${amount} ${label.slice(0, -1)}`
    }
  } else {
    return '';
  }
}

export {
  getDefaultRange,
  rangeToButtonLabel,
  fromApiDate,
  toApiDate,
  getDuration
}